/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import ViewFullReview from "./ViewFullReview";
import reviewType from "./types/reviewType";
import { loadRecruiterReviews } from "../../actions/agencyProfileActions";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import {
  Wrapper,
  Review,
  Top,
  Info,
  Name,
  Date,
  StarRating,
  FillRating,
  EmptyRating,
  Stars,
  Text,
  ReadMore,
  PaginationButtons,
  PrevButtonWrapper,
  PrevButton,
  NextButtonWrapper,
  NextButton,
} from "./styles/reviews-styles";

export class Reviews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromIndex: 0,
      toIndex: 3,
      currentPage: 1,
      perPageCount: 3,
      fullReview: false,
      fullReviewData: null,
    };
  }

  componentDidMount() {
    const reviewsLink = document.getElementById("reviews-link");
    const { currentPage, perPageCount } = this.state;
    const { loadRecruiterReviews, recruiterId } = this.props;

    loadRecruiterReviews(recruiterId, currentPage, perPageCount);
    reviewsLink.classList.add("active");
  }

  componentWillUnmount() {
    const reviewsLink = document.getElementById("reviews-link");
    reviewsLink.classList.remove("active");
  }

  handleTextLength = (text) => {
    if (text && text.length > 200) {
      return `"${text.slice(0, 200)}..."${" "}`;
    }
    return `"${text}..."`;
  };

  handlePrevButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const nextPage = currentPage - 1;
    const { loadRecruiterReviews, recruiterId } = this.props;

    loadRecruiterReviews(recruiterId, nextPage, perPageCount);
    if (currentPage > 1) {
      this.setState({
        fromIndex: fromIndex - perPageCount,
        toIndex: toIndex - perPageCount,
        currentPage: currentPage - 1,
      });
    }
  };

  handleNextButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const nextPage = currentPage + 1;
    const { loadRecruiterReviews, recruiterId } = this.props;

    loadRecruiterReviews(recruiterId, nextPage, perPageCount);
    this.setState({
      fromIndex: fromIndex + perPageCount,
      toIndex: toIndex + perPageCount,
      currentPage: nextPage,
    });
  };

  handleReadMore = (review) => {
    const { fullReview } = this.state;
    this.setState({
      fullReview: !fullReview,
      fullReviewData: review,
    });
  };

  render() {
    const { employerReviews, employerReviewsTotal, reviewsLoading } =
      this.props;
    const { currentPage, fullReview, fullReviewData, perPageCount } =
      this.state;
    const displayedReviewsCount = currentPage * perPageCount;

    if (employerReviews.length > 0) {
      return (
        <Wrapper>
          {reviewsLoading && <WidgetLoading />}
          {fullReview && (
            <ViewFullReview
              review={fullReviewData}
              handleClose={this.handleReadMore}
            />
          )}
          {employerReviews.map((review) => (
            <Review key={review.id}>
              <Top>
                <Info>
                  <Name data-test-id="review-employer-name">
                    {(review.employer && review.employer.name) || "Anonymous"}
                  </Name>
                  <Date data-test-id="review-created-at">
                    {review.createdAt}
                  </Date>
                </Info>
                <StarRating>
                  <FillRating style={{ width: `${review.average}%` }}>
                    <Stars>★★★★★</Stars>
                  </FillRating>
                  <EmptyRating>
                    <Stars>★★★★★</Stars>
                  </EmptyRating>
                </StarRating>
              </Top>
              <Text data-test-id="review-message">
                {this.handleTextLength(review.message)}
                {review.message && review.message.length > 200 && (
                  <ReadMore onClick={() => this.handleReadMore(review)}>
                    read more
                  </ReadMore>
                )}
              </Text>
            </Review>
          ))}
          <PaginationButtons>
            <PrevButtonWrapper>
              {currentPage > 1 && (
                <PrevButton onClick={this.handlePrevButton}>
                  <FontAwesomeIcon icon={faChevronLeft} /> prev
                </PrevButton>
              )}
            </PrevButtonWrapper>
            <NextButtonWrapper>
              {displayedReviewsCount < employerReviewsTotal && (
                <NextButton onClick={this.handleNextButton}>
                  next <FontAwesomeIcon icon={faChevronRight} />
                </NextButton>
              )}
            </NextButtonWrapper>
          </PaginationButtons>
        </Wrapper>
      );
    }
    return <Wrapper noReviews>no reviews yet</Wrapper>;
  }
}

Reviews.propTypes = {
  loadRecruiterReviews: PropTypes.func.isRequired,
  recruiterId: PropTypes.number.isRequired,
  employerReviews: PropTypes.arrayOf(reviewType).isRequired,
  employerReviewsTotal: PropTypes.number.isRequired,
  reviewsLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  recruiterId: state.agencyProfile.profileData.user.companyId,
  employerReviews: state.agencyProfile.profileData.employerReviews,
  employerReviewsTotal: state.agencyProfile.profileData.employerReviewsTotal,
  reviewsLoading: state.agencyProfile.reviewsLoading,
});

export default connect(mapStateToProps, { loadRecruiterReviews })(Reviews);
